import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function InternationalPhoneInput({ id, value, onChange, placeholder = "Phone number" }) {
  const normalizedValue = String(value || "").replace(/\D/g, "");

  return (
    <>
      <style>{`
        /* ── Mama Bacamel phone input overrides ── */

        /* Container: kill the default bottom margin the lib adds */
        .mama-phone-wrap .react-tel-input {
          font-family: 'Lato', sans-serif;
        }

        /* The text input itself */
        .mama-phone-wrap .react-tel-input .form-control {
          width: 100% !important;
          height: 42px !important;
          border-radius: 10px !important;
          border: 1.5px solid var(--border) !important;
          background: var(--beige) !important;
          color: var(--text-main) !important;
          font-size: 0.95rem !important;
          font-family: 'Lato', sans-serif !important;
          padding-left: 52px !important;
          transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
          outline: none !important;
        }

        .mama-phone-wrap .react-tel-input .form-control:focus {
          border-color: var(--orange) !important;
          box-shadow: 0 0 0 3px rgba(224, 123, 57, 0.15) !important;
        }

        /* Flag button */
        .mama-phone-wrap .react-tel-input .flag-dropdown {
          border: 1.5px solid var(--border) !important;
          border-right: none !important;
          border-radius: 10px 0 0 10px !important;
          background: #EED6AF !important;
          transition: background 0.15s ease !important;
        }

        .mama-phone-wrap .react-tel-input .flag-dropdown:hover,
        .mama-phone-wrap .react-tel-input .flag-dropdown.open {
          background: #E5C99A !important;
          border-color: var(--orange) !important;
        }

        .mama-phone-wrap .react-tel-input .flag-dropdown.open {
          border-radius: 10px 0 0 10px !important;
        }

        .mama-phone-wrap .react-tel-input .selected-flag {
          border-radius: 10px 0 0 10px !important;
          padding: 0 0 0 11px !important;
          background: transparent !important;
        }

        .mama-phone-wrap .react-tel-input .selected-flag:hover,
        .mama-phone-wrap .react-tel-input .selected-flag:focus {
          background: transparent !important;
        }

        /* The caret arrow inside the button */
        .mama-phone-wrap .react-tel-input .selected-flag .arrow {
          border-top-color: var(--brown-mid) !important;
        }

        .mama-phone-wrap .react-tel-input .selected-flag .arrow.up {
          border-bottom-color: var(--orange) !important;
          border-top-color: transparent !important;
        }

        /* ── DROPDOWN PANEL ── */
        .mama-phone-wrap .react-tel-input .country-list {
          background: var(--warm-white) !important;
          border: 1.5px solid var(--border) !important;
          border-radius: 12px !important;
          box-shadow: 0 8px 32px rgba(92, 51, 23, 0.14) !important;
          margin-top: 4px !important;
          padding: 6px 0 !important;
          max-height: 240px !important;
          width: 300px !important;
          overflow-y: auto !important;
          font-family: 'Lato', sans-serif !important;

          /* Custom scrollbar */
          scrollbar-width: thin;
          scrollbar-color: var(--border) transparent;
        }

        .mama-phone-wrap .react-tel-input .country-list::-webkit-scrollbar {
          width: 5px;
        }
        .mama-phone-wrap .react-tel-input .country-list::-webkit-scrollbar-track {
          background: transparent;
        }
        .mama-phone-wrap .react-tel-input .country-list::-webkit-scrollbar-thumb {
          background: var(--border);
          border-radius: 999px;
        }

        /* Search box inside dropdown */
        .mama-phone-wrap .react-tel-input .country-list .search {
          padding: 8px 10px !important;
          border-bottom: 1px solid var(--border) !important;
          background: var(--warm-white) !important;
          position: sticky !important;
          top: 0 !important;
          z-index: 1 !important;
        }

        .mama-phone-wrap .react-tel-input .country-list .search-box {
          width: 100% !important;
          box-sizing: border-box !important;
          border: 1.5px solid var(--border) !important;
          border-radius: 8px !important;
          background: var(--beige) !important;
          color: var(--text-main) !important;
          font-size: 0.88rem !important;
          font-family: 'Lato', sans-serif !important;
          padding: 6px 10px !important;
          outline: none !important;
          transition: border-color 0.2s ease !important;
        }

        .mama-phone-wrap .react-tel-input .country-list .search-box:focus {
          border-color: var(--orange) !important;
        }

        /* Individual country row */
        .mama-phone-wrap .react-tel-input .country-list .country {
          padding: 8px 14px !important;
          font-size: 0.88rem !important;
          color: var(--text-main) !important;
          transition: background 0.12s ease !important;
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
        }

        .mama-phone-wrap .react-tel-input .country-list .country:hover {
          background: var(--beige) !important;
        }

        .mama-phone-wrap .react-tel-input .country-list .country.highlight {
          background: rgba(224, 123, 57, 0.12) !important;
        }

        /* Country name text */
        .mama-phone-wrap .react-tel-input .country-list .country .country-name {
          color: var(--text-main) !important;
          font-size: 0.88rem !important;
        }

        /* Dial code text next to country name */
        .mama-phone-wrap .react-tel-input .country-list .country .dial-code {
          color: var(--text-muted) !important;
          font-size: 0.82rem !important;
        }

        /* Divider between preferred and other countries */
        .mama-phone-wrap .react-tel-input .country-list .divider {
          border-bottom: 1px solid var(--border) !important;
          margin: 4px 0 !important;
          padding: 0 !important;
        }
      `}</style>

      <div className="mama-phone-wrap">
        <PhoneInput
          country="my"
          enableSearch
          searchPlaceholder="Search country"
          countryCodeEditable={false}
          disableSearchIcon
          disableDropdown={false}
          enableAreaCodes={false}
          disableCountryGuess
          value={normalizedValue}
          onChange={(rawValue, countryData) => {
            const dialCode = String(countryData?.dialCode || "");
            let digits = String(rawValue || "").replace(/\D/g, "");

            if (dialCode && digits.startsWith(dialCode)) {
              const localNumber = digits.slice(dialCode.length).replace(/^0+/, "");
              digits = dialCode + localNumber;
            }

            onChange(digits ? `+${digits}` : "");
          }}
          inputProps={{
            id,
            name: id,
            required: false,
            autoComplete: "tel",
          }}
          containerStyle={{ marginBottom: "0.75rem" }}
          specialLabel=""
          placeholder={placeholder}
          masks={{ my: "..-....-....", my: "..-..-...-...." }}
        />
      </div>
    </>
  );
}

export default InternationalPhoneInput;